module.exports = __webpack_public_path__ + "static/media/pixeltree-logo.8c492ba9.png";